import { Link } from "@tanstack/react-router";
import { SectionMark } from "@/components/section-mark";
import { PhotoFigure } from "@/components/photo-figure";
import teamPhoto from "@/assets/sylwia-portret-osobisty.jpg.asset.json";
import awardPhoto from "@/assets/sylwia-nagroda.jpg.asset.json";

const credentials: string[] = [
  "Psycholog",
  "Psychoterapeutka CBT",
  "Przedsiębiorczyni",
  "10 000 h pracy 1:1",
];

const awards = [
  "Diament Biznesu, Forum Biznesu Polska, gala Business Power",
  "Wyróżnienie XXV Gali Businesswoman Awards",
  "Nagroda „Sukces w Szpilkach”, XII Polski Kongres Przedsiębiorczości, 2025",
];

export function AboutSection() {
  return (
    <section id="o-mnie" className="content-visibility-auto scroll-mt-24 border-b border-ink/10">
      <div className="grid md:grid-cols-[0.9fr_1.1fr]">
        <div className="border-b border-ink/10 bg-steel-soft md:border-b-0 md:border-r">
          <PhotoFigure
            src={teamPhoto.url}
            alt="Sylwia Sitkowska w czarnym swetrze, siedząca przy stole podczas rozmowy"
            figureClassName="h-full"
            className="h-full"
            imgClassName="h-full min-h-[20rem] w-full object-cover object-[50%_28%] md:min-h-[34rem] md:object-[50%_30%]"
            width={1170}
            height={1560}
          />
        </div>
        <div className="px-6 py-12 md:px-10 md:py-16 lg:px-12">
          <SectionMark number="09" label="O mnie" />
          <h2 className="display-xl mt-8 text-[1.9rem] md:text-[2.7rem]">
            Rozumiem człowieka, ale rozumiem też{" "}
            <span className="serif-display italic text-coral-text">biznes</span>
          </h2>
          <div className="mt-8 h-px w-full bg-steel" />
          <div className="measure-text mt-8 space-y-6">
            <p className="lead-serif">
              Od 2009 roku łączę pracę psychologa i psychoterapeutki z doświadczeniem
              przedsiębiorczyni.
            </p>
            <p className="text-base leading-relaxed text-ink/80 md:text-lg">
              Moje doświadczenie zawodowe rozwijało się równolegle w dwóch światach: w gabinecie
              i w biznesie. Z jednej poradni powstała{" "}
              <a
                href="https://www.przystan-psychologiczna.pl/"
                target="_blank"
                rel="noopener noreferrer"
                className="border-b border-coral/60 text-ink transition-colors hover:text-coral-text"
              >
                Przystań Psychologiczna
              </a>
              , którą założyłam i którą prowadzę do dziś. Dzięki temu patrzę na człowieka zarówno
              z perspektywy psychologicznej, jak i z perspektywy realnej odpowiedzialności za
              decyzje, ludzi i rozwój firmy.
            </p>
          </div>

          {credentials.length > 0 && (
            <div className="mt-10 max-w-2xl border-t border-steel pt-8">
              <p className="eyebrow">Doświadczenie</p>
              <div className="mt-6 grid gap-3 sm:grid-cols-2">
                {[credentials.slice(0, 3), credentials.slice(3, 6)].map((column, index) => (
                  <ul key={index} className="space-y-3">
                    {column.map((item) => (
                      <li
                        key={item}
                        className="flex gap-3 text-base leading-relaxed text-ink/80"
                      >
                        <span aria-hidden="true" className="text-coral-text">
                          ·
                        </span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                ))}
              </div>
            </div>
          )}

          <div className="mt-8 max-w-2xl border-t border-steel pt-8">
            <p className="eyebrow">Wyróżnienia</p>
            <div className="mt-6 grid items-start gap-6 sm:grid-cols-[1fr_9rem]">
              <ul className="space-y-3">
                {awards.map((item) => (
                  <li key={item} className="flex gap-3 text-base leading-relaxed text-ink/80">
                    <span aria-hidden="true" className="text-coral-text">
                      ·
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <PhotoFigure
                src={awardPhoto.url}
                alt="Sylwia Sitkowska z wyróżnieniem podczas gali Businesswoman Awards"
                className="aspect-[4/3] w-full object-cover object-center"
                width={1600}
                height={1066}
              />
            </div>
          </div>

          <Link
            to="/o-mnie"
            hash="moja-historia"
            className="btn-base btn-outline mt-8 inline-flex min-h-11 items-center justify-center"
          >
            Poznaj moją historię
          </Link>
        </div>
      </div>
    </section>
  );
}
